import { flightReducersMap } from "@b2bportal/core-flights";
import { combineReducers } from "@reduxjs/toolkit";
import flightShopReducer from "./shop/store/slice";
import type { FlightState } from "./types";

// Re-export FlightState for backwards compatibility
export type { FlightState };

export const flightsReducer = combineReducers({
  ...flightReducersMap,
  flightShop: flightShopReducer,
});
